export * as reselct from 'reselect';
import { createSelectorCreator, lruMemoize } from 'reselect';
import isEqual from 'lodash-es/isEqual';

export const createDeepEqualSelector = createSelectorCreator(lruMemoize, { resultEqualityCheck: isEqual });

export default (options) => {
  const maxSize = options.maxSize || 1;
  const resultEqualityCheck = options.resultEqualityCheck || isEqual;
  const equalityCheck = options.equalityCheck || function defaultEqualityCheck(a, b) { return a === b; };
  return createSelectorCreator(lruMemoize, {resultEqualityCheck, maxSize, equalityCheck});
};